import { render } from "./LogoSistema.vue?vue&type=template&id=5ac23bda"
import script from "./LogoSistema.vue?vue&type=script&lang=js"
export * from "./LogoSistema.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__